import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import {
  Row,
  Col,
  Button,
  Collapse,
  Icon,
  DatePicker,
  Select,
  Alert,
} from "antd";
import moment from "moment";
import "moment/locale/es";

const { RangePicker } = DatePicker;
const { Option } = Select;
const { Panel } = Collapse;

function AlarmsSearch({
  onSearch,
  onDateChange,
  onExtraFilterChange,
  filterOptions,
  searchParameters,
  selectedLabels,
}) {
  const [dateError, setDateError] = useState(null);

  const predefinedRanges = {
    Hoy: [moment().startOf("day"), moment().endOf("day")],
    "Últimas 3h": [moment().subtract(3, "hours"), moment()],
    "Últimas 12h": [moment().subtract(12, "hours"), moment()],
    "Últimas 24h": [moment().subtract(24, "hours"), moment()],
    "Últimos 7 días": [moment().subtract(7, "days"), moment()],
  };

  const handleKeyDown = (e) => e.preventDefault();

  const handleSearchAlarms = (e) => {
    e.preventDefault();
    onSearch();
  };

  const handleDateChangeInternal = (dates) => {
    if (dates && dates[0] && dates[1]) {
      const diff = dates[1].diff(dates[0], "months", true);
      if (diff > 1) {
        setDateError("El rango máximo permitido es de un mes.");
        onDateChange([null, null]);
        return;
      }
    }
    setDateError(null);
    onDateChange(dates);
  };

  const isDisabled =
    !searchParameters.onDateRangePicked &&
    !searchParameters.startDateAlarm &&
    !searchParameters.endDateAlarm;

  return (
    <div className="AlarmsSearch">
      {dateError && (
        <Alert
          className="alert-error"
          message={dateError}
          type="error"
          showIcon
        />
      )}

      <h2>Buscador de Alarmas</h2>

      <Row>
        <Collapse
          defaultActiveKey={["1"]}
          expandIcon={({ isActive }) => (
            <Icon type="caret-right" rotate={isActive ? 90 : 0} />
          )}
        >
          <Panel
            header="Buscador"
            key="1"
            extra={<Icon type="minus-circle" />}
            className="Busca"
          >
            <form onSubmit={handleSearchAlarms}>
              <Row
                className="alarms-grid-row"
                gutter={{ xs: 16, sm: 24, md: 32, lg: 40, xl: 48 }}
                type="flex"
              >
                <Col xs={24} lg={10} className="alarms-field">
                  <label>Rango de fechas</label>
                  <RangePicker
                    className="alarms-control"
                    showTime={{ format: "HH:mm" }}
                    format="DD-MM-YYYY  HH:mm"
                    placeholder={["Desde", "Hasta"]}
                    onChange={handleDateChangeInternal}
                    ranges={predefinedRanges}
                    value={
                      searchParameters.startDateAlarm &&
                      searchParameters.endDateAlarm
                        ? [
                            searchParameters.startDateAlarm,
                            searchParameters.endDateAlarm,
                          ]
                        : null
                    }
                  />
                </Col>

                <Col xs={24} lg={10} className="alarms-field">
                  <label>Tipos de alarmas</label>
                  <Select
                    className="alarms-control"
                    mode="multiple"
                    value={selectedLabels}
                    onChange={onExtraFilterChange}
                    placeholder="Filtre los tipos de alarmas para una búsqueda avanzada"
                    onInputKeyDown={handleKeyDown}
                  >
                    {filterOptions.map((item) => (
                      <Option key={item.value} value={item.label}>
                        {item.label}
                      </Option>
                    ))}
                  </Select>
                </Col>

                <Col xs={24} lg={4} className="alarms-actions">
                  <Button
                    type="submit"
                    htmlType="submit"
                    disabled={isDisabled}
                    className={isDisabled ? "disabled" : "search-btn"}
                  >
                    Buscar
                  </Button>
                </Col>
              </Row>
            </form>
          </Panel>
        </Collapse>
      </Row>
    </div>
  );
}

export default withTranslation()(AlarmsSearch);
